import { MaterializedImageWithPoints } from '@fagmobler/sanity';
import { ALGOLIA_INDEX_NAME } from '@/lib/algolia/searchClient';
import { FagmoblerAlgoliaProduct } from '@fagmobler/types';

export type MaterializedImageWithPointsWithProducts =
  | (MaterializedImageWithPoints & {
      points: (MaterializedImageWithPoints['points'] & {
        product: FagmoblerAlgoliaProduct | null;
      })[];
    })
  | null;

export const populateImageWithPointsWithProducts = async (
  imageWithPoints: MaterializedImageWithPoints
): Promise<MaterializedImageWithPointsWithProducts> => {
  if (!imageWithPoints.points) return null;
  const { searchClient } = await import('@/lib/algolia/searchClient');
  const index = searchClient.initIndex(ALGOLIA_INDEX_NAME);
  // Image with points
  if (imageWithPoints.points?.length > 0) {
    const SKUs = imageWithPoints.points.map((point: any) => point.productSKU);
    const products = await index
      .getObjects<FagmoblerAlgoliaProduct>(SKUs.filter(Boolean))
      .then(
        (data) => data.results.filter(Boolean) as FagmoblerAlgoliaProduct[]
      );

    return {
      ...imageWithPoints,
      points: imageWithPoints.points.map((point: any) => {
        const product =
          products.find((p) => p.objectID === point.productSKU) || null;
        return {
          ...point,
          product,
        };
      }),
    };
  }
  return null;
};
